export const WHATSAPP_NUMBER = "905421850201";

/**
 * Builds a WhatsApp deep link with a pre-filled, URL-encoded message.
 */
export function buildWhatsAppLink(message: string): string {
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
}

export const TEL_LINK = "tel:+905421850201";
export const INSTAGRAM_LINK = "https://instagram.com/fatmaangay.guzellik";

export const MAPS_DIRECTIONS_LINK =
  "https://www.google.com/maps/dir/?api=1&destination=Demirta%C5%9F%20Sakarya%20Mahallesi%20Demirta%C5%9F%20Sanayi%20%C3%87evre%20Yolu%20Caddesi%20No%3A2%2F1%20Osmangazi%20Bursa";

export const MAPS_EMBED_SRC =
  "https://www.google.com/maps?q=Demirta%C5%9F%20Sakarya%20Mahallesi%20Demirta%C5%9F%20Sanayi%20%C3%87evre%20Yolu%20Caddesi%202%2F1%20Osmangazi%20Bursa&output=embed";